import { render, staticRenderFns } from "./training.vue?vue&type=template&id=fa43b9fa&scoped=true"
import script from "./training.vue?vue&type=script&lang=js"
export * from "./training.vue?vue&type=script&lang=js"
import style0 from "./training.vue?vue&type=style&index=0&id=fa43b9fa&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa43b9fa",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\gitee\\fcops_front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fa43b9fa')) {
      api.createRecord('fa43b9fa', component.options)
    } else {
      api.reload('fa43b9fa', component.options)
    }
    module.hot.accept("./training.vue?vue&type=template&id=fa43b9fa&scoped=true", function () {
      api.rerender('fa43b9fa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/personnel/training.vue"
export default component.exports